export default [
  {
    path: '/invites',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'invites-list' */ '@/views/invites/List.vue')
  },
]
